import { render } from "./SetNewPassword.vue?vue&type=template&id=46c82998&scoped=true"
const script = {}

import "./SetNewPassword.vue?vue&type=style&index=0&id=46c82998&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c82998"]])

export default __exports__